import { Stack, Avatar, Paper, Popper } from "@mui/material";
import { AssigneeDetails } from "./AssigneeDetails";
import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

interface User {
  id?: string;
  first_name: string;
  email: string;
  profile_picture_url?: string;
}

interface Props {
  assignees: User[];
}

export const TableRowAssignees: React.FC<Props> = ({ assignees }) => {
  const [assigneeDetailsOpen, setAssigneeDetailsOpen] = useState(false);
  const stackRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const stackEl = stackRef.current;
    if (!stackEl) return;

    const displayPaperView = () => {
      setAssigneeDetailsOpen(true);
    };

    const hidePaperView = () => {
      setAssigneeDetailsOpen(false);
    };

    stackEl.addEventListener("mouseenter", displayPaperView);
    stackEl.addEventListener("mouseleave", hidePaperView);

    return () => {
      stackEl.removeEventListener("mouseenter", displayPaperView);
      stackEl.removeEventListener("mouseleave", hidePaperView);
    };
  }, []);
  return (
    <>
      <Stack
        ref={stackRef}
        direction={"row"}
        gap={"-2"}
        sx={{ cursor: "pointer", mt: 2 }}
      >
        {assignees.slice(0, 3).map((assignee, index) => {
          return (
            <Avatar
              key={assignee.id ?? index}
              alt="user picture"
              sx={{
                width: 25,
                height: 25,
                border: "1px solid #fff",
                position: index > 0 ? "relative" : "static", // allowing avatars to overlay
                left: index === 0 ? 0 : -10 * index, // allowing avatars to overlay
              }}
              src={assignee.profile_picture_url || undefined}
            >
              {assignee.first_name.charAt(0).toUpperCase()}
            </Avatar>
          );
        })}
      </Stack>
      <Popper
        open={assigneeDetailsOpen}
        anchorEl={stackRef.current}
        placement="left-end"
        style={{
          zIndex: 1,
          backgroundColor: "white",
        }}
      >
        <Paper
          style={{
            //width: "",
            position: "absolute",
            zIndex: 100,
            padding: 5,
            left: "-38px",
            width: "180px",
            // backgroundColor: "white",
          }}
        >
          {assignees.map((assignee, index) => {
            return (
              <AssigneeDetails
                key={index}
                firstName={assignee.email.split("@")[0]}
                lastName=""
                profileImg={
                  assignee.profile_picture_url ||
                  assignee.first_name.charAt(0).toUpperCase()
                }
              />
            );
          })}
        </Paper>
      </Popper>
    </>
  );
};

TableRowAssignees.propTypes = {
  assignees: PropTypes.arrayOf(PropTypes.object).isRequired,
};
